/** Remote-control agent status payloads are often objects — never render "[object Object]". */
export function formatRemoteControlLastStatus(value: unknown): string | null {
  if (value == null || value === '') return null;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    const preferred = o.reason ?? o.status ?? o.state ?? o.message ?? o.code ?? o.lastError;
    if (preferred != null && (typeof preferred === 'string' || typeof preferred === 'number' || typeof preferred === 'boolean')) {
      return String(preferred);
    }
    try {
      const json = JSON.stringify(value);
      return json && json !== '{}' ? json.slice(0, 64) : null;
    } catch {
      return null;
    }
  }
  return null;
}
